import { BAVBenefitDetailsDTO, BenefitDTO } from 'probonio-shared-ui/api';
import { BENEFIT_PICTURES } from 'probonio-shared-ui/component/button';
import {
  BenefitListItemExtensionInterface,
  BenefitListItemProps,
} from '../../../extension/interface/benefit-list-item.extension.interface';
import { getBenefitIcon } from '../../benefit/BenefitIcon';

export class BAVBenefitListItemExtension extends BenefitListItemExtensionInterface {
  isHidden(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[], context?: Record<string, unknown>): boolean {
    const bavDetails = activeBenefit.details as BAVBenefitDetailsDTO;
    const bavNotInterested = context?.bavNotInterested as boolean;
    return !bavDetails.activeContract && !!bavNotInterested;
  }

  getListItemProps(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[]): BenefitListItemProps {
    const detailsBAV = activeBenefit.details as BAVBenefitDetailsDTO;

    const totalPremium =
      (detailsBAV.activeContract?.employeePremiumGross || 0) +
      (detailsBAV.activeContract?.employerGrant || 0) +
      (detailsBAV.activeContract?.vwlConversion || 0);

    return {
      icon: getBenefitIcon(activeBenefit.benefit),
      titleKey: `benefit.${activeBenefit.benefit}.${detailsBAV.activeContract ? 'name' : 'nameNoContract'}`,
      navigateTo: '/bav',
      picture: BENEFIT_PICTURES[activeBenefit.benefit],
      descriptionKey: `benefitModule:benefit.${activeBenefit.benefit}.${
        detailsBAV.activeContract ? 'description' : 'descriptionNoContract'
      }`,
      descriptionValues: { totalPremium },
      benefitProgress: detailsBAV.activeContract ? 100 : 0,
    };
  }
}
